import type {
  RatingCountsByStarFragment,
  ReviewFragment,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';
import type { CourseFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SpecializationEntitiesFragments';

export type SpecializationReviewFragment = ReviewFragment & { courseId: string };

// TODO(MERCH-3262): Remove once the specialization reviews API exists. These stand in for the
// not-yet-available topReviews/ratingCountsByStar data on the specialization page query.
const MOCK_REVIEW_CONTENT: Array<Omit<ReviewFragment, 'id'>> = [
  {
    rating: 5,
    authorName: 'SD',
    comment:
      'The best course I have done till date. The humble and cool nature of the instructors really kept me going and this gives almost all the basic knowledge required in this field.',
    timestamp: '2021-09-12',
  },
  {
    rating: 5,
    authorName: 'KW',
    comment:
      "Awesome program. Found out why I'm always analytical about things in my personal life and the critical thinking that this provides. I love it and hopefully this will help me land my dream job!",
    timestamp: '2021-06-25',
  },
  {
    rating: 4,
    authorName: 'AR',
    comment:
      'Great overview across the whole specialization. The pacing was reasonable and the projects tied the courses together nicely.',
    timestamp: '2021-04-02',
  },
];

export const MOCK_RATING_COUNTS_BY_STAR: RatingCountsByStarFragment = {
  fiveStarRatingCount: 10000,
  fourStarRatingCount: 10000,
  threeStarRatingCount: 250,
  twoStarRatingCount: 200,
  oneStarRatingCount: 25,
};

// Explicitly for the standalone specialization reviews page's "Top reviews" carousel
// (SpecializationReviewsPageContent) -- the XDP reviews module gets its review cards from the
// real per-course query (useCourseReviews) instead.
export const getMockReviewsPageTopReviews = (
  courses?: Array<Pick<CourseFragment, 'id'>> | null,
  selectedCourseId?: string
): SpecializationReviewFragment[] => {
  if (!courses?.length) {
    return [];
  }

  return MOCK_REVIEW_CONTENT.map((review, index) => {
    const fallbackCourse = courses[index % courses.length];
    return {
      ...review,
      id: `mock-specialization-review-${index}`,
      courseId: selectedCourseId ?? fallbackCourse?.id ?? courses[0]?.id ?? '',
    };
  });
};

export const getCourseIdToNameMap = (
  courses?: Array<Pick<CourseFragment, 'id' | 'name'>> | null
): Map<string, string> => new Map((courses ?? []).map((course) => [course.id, course.name]));

export const getCourseFilterOptions = (
  courses?: Array<Pick<CourseFragment, 'slug' | 'name'>> | null
): Array<Pick<CourseFragment, 'slug' | 'name'>> =>
  Array.from(new Map((courses ?? []).map((course) => [course.slug, course])).values());
